import React from 'react'
import { User } from '../../types/User'
import AcklenLogo from './AcklenLogo'

const Footer = ({ user }: { user: User | undefined }): JSX.Element => {
  return user ? (
    <footer className="global-footer">
      <div className="global-footer__inner">
        <span>© All rights reserved. Acklen Avenue.</span>
        <div className="global-footer__powered-by">
          <span>Powered by</span>
          <AcklenLogo className="global-footer__logo" />
        </div>
      </div>
    </footer>
  ) : (
    <></>
  )
}

export default Footer
